<template>
  <QDialog
    ref="dialog"
    @hide="onDialogHide"
    transition-show="jump-up"
    transition-hide="jump-down"
    v-bind="$attrs"
  >
    <QCard
      class="column q-py-md rounded-borders-lg no-wrap"
      :style="{ 'max-width': maxWidth }"
    >
      <div class="row full-width justify-end q-px-sm" v-if="displayHideAction">
        <SAIIconBtn @click="hide" color="grey-6" />
      </div>
      <slot />
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard } from 'quasar';

export default {
  name: 'SAIDialogWrapper',
  props: {
    displayHideAction: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: '360px'
    }
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide() {
      this.$emit('hide');
    }
  },
  components: {
    QDialog,
    QCard,
    SAIIconBtn: () => import('../../atom/sai-icon-btn')
  }
};
</script>

<style lang="sass" scoped>
.q-dialog::v-deep
  .q-dialog__backdrop
    background: rgba(5,22,41,0.2)
</style>
